import { Modal } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import useAuthSessionStore from "../stores/auth-session-store";
import useUserStore from "../stores/user-store";
import LoginForm from "../auth/login-form";
import { clearAuthSession, completeInteractiveLogin, cancelInteractiveLogin } from "../new/auth-session";
import { useLogoutMutation } from "../new/auth.query";

const SessionExpiredModal = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const queryClient = useQueryClient();
    const { reauthRequired, message } = useAuthSessionStore((state) => ({
        reauthRequired: state.reauthRequired,
        message: state.message
    }));
    const { username, passkeyConfigured } = useUserStore((state) => ({
        username: state.username,
        passkeyConfigured: state.passkeyConfigured
    }));
    const logoutMutation = useLogoutMutation();

    const handleSignOut = async () => {
        cancelInteractiveLogin();

        try {
            await logoutMutation.mutateAsync();
        } catch {
            clearAuthSession();
            queryClient.clear();
        }

        const returnTo = `${location.pathname ?? ""}${location.search ?? ""}${location.hash ?? ""}` || "/";
        navigate(`/Auth/Login?returnTo=${encodeURIComponent(returnTo)}`, { replace: true });
    };

    return (
        <Modal show={reauthRequired} backdrop="static" keyboard={false} centered>
            <Modal.Header>
                <Modal.Title>Session Expired</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className="text-muted mb-3">{message}</p>
                <LoginForm
                    defaultUsername={username ?? ""}
                    usernameReadOnly={!!username}
                    focusPassword={!passkeyConfigured}
                    submitLabel="Continue Working"
                    secondaryActionLabel="Sign Out"
                    secondaryActionVariant="outline-secondary"
                    secondaryActionClassName=""
                    onSecondaryAction={handleSignOut}
                    onSuccess={(session) => completeInteractiveLogin(session)}
                />
            </Modal.Body>
        </Modal>
    );
};

export default SessionExpiredModal;
